import React, { useState, useContext } from 'react';
import {
	Wrapper,
	Container,
	CategoryInsightData,
	CategoryInsightLabel,
	CategoryInsightValue,
	CategoryInsightRow,
	LoaderWrapper,
	AbortPopup,
	ModalBody,
} from './InsightsSettings.styles';
import {
	ApButtonSecondary,
	ApInput,
	ApLoaderDefault,
	ApLoaderText,
} from '@alixpartners/ui-components';
import { CategoryInsightsSettingsContext } from 'contexts/CategoryInsightsSettingsContext/index';
import { updateCategoryInsightSettings } from 'utils/apiRequests';
import Modal from 'components/Modal';
import { MultiSelectWrapper } from './InsightsSettings.styles';
import VendorMultiSelect from './VendorMultiSelect';

const InsightsSettings = props => {
	const { onSaveSettings } = props;
	const [edited, setEdited] = useState(true);
	const {
		fragmentation,
		vendorCountMax,
		wellmanaged,
		vendorCountMin,
		paymentTerms,
		pCardCategories,
		selectedOption,
		option,
		loading,
		updateValue,
		isSaving,
	} = useContext(CategoryInsightsSettingsContext);
	const updateSettings = (
		fragment,
		countMax,
		wellmanage,
		countMin,
		payment,
		percentage,
		select
	) => {
		onSaveSettings(true);
		updateCategoryInsightSettings(
			{
				fragmentedCategories: { threshold: fragment, vendorCountMax: countMax },
				wellManagedCategories: {
					threshold: wellmanage,
					vendorCountMin: countMin,
				},
				outOfPolicySpend: { vendorName: [...select] },
				PaymentTerms: { threshold: payment },
				pCardCategories: { threshold: percentage },
			},
			'settings'
		).then(() => {
			onSaveSettings(false);
		});
	};

	const renderSavingBlock = () => {
		return (
			<>
				{isSaving && (
					<AbortPopup>
						<Modal width="550px" zIndex="10000000">
							<ModalBody>
								Saving settings, please wait.<br />
								<ApLoaderDefault loaderText={() => <ApLoaderText />} />
							</ModalBody>
						</Modal>
					</AbortPopup>
				)}
			</>
		);
	};

	return loading ? (
		<LoaderWrapper>
			<ApLoaderDefault loaderText={() => <ApLoaderText />} />
		</LoaderWrapper>
	) : (
		<Wrapper>
			<Container>
				{isSaving && renderSavingBlock()}
				<CategoryInsightData>
					<CategoryInsightRow>
						<CategoryInsightLabel>
							Fragmentation threshold:
						</CategoryInsightLabel>
						<CategoryInsightValue>
							<ApInput
								type="number"
								name="fragmentation"
								value={fragmentation || ' '}
								onChange={v => {
									updateValue('fragmentation', v);
									setEdited(false);
								}}
							/>
						</CategoryInsightValue>
					</CategoryInsightRow>
					<CategoryInsightRow>
						<CategoryInsightLabel>
							Fragmentation Vendor threshold:
						</CategoryInsightLabel>
						<CategoryInsightValue>
							<ApInput
								type="number"
								name="vendorCountMax"
								value={vendorCountMax || ' '}
								onChange={v => {
									if (v === '') {
										updateValue('vendorCountMax', v);
									} else {
										if (Number(v) > Number(vendorCountMin)) {
											updateValue('vendorCountMax', v);
											setEdited(false);
										} else if (Number(v) < Number(vendorCountMin)) {
											updateValue('vendorCountMax', v);
											updateValue('vendorCountMin', v);
										}
									}
								}}
							/>
						</CategoryInsightValue>
					</CategoryInsightRow>
					<CategoryInsightRow>
						<CategoryInsightLabel>Wellmanaged threshold:</CategoryInsightLabel>
						<CategoryInsightValue>
							<ApInput
								type="number"
								name="well-managed"
								value={wellmanaged || ''}
								onChange={v => {
									updateValue('wellmanaged', v);
									setEdited(false);
								}}
							/>
						</CategoryInsightValue>
					</CategoryInsightRow>
					<CategoryInsightRow>
						<CategoryInsightLabel>
							Wellmanaged Vendor threshold:
						</CategoryInsightLabel>
						<CategoryInsightValue>
							<ApInput
								type="number"
								name="vendorCountMin"
								value={vendorCountMin || ' '}
								onChange={v => {
									if (v === '') {
										updateValue('vendorCountMin', v);
									} else {
										if (Number(v) < Number(vendorCountMax)) {
											updateValue('vendorCountMin', v);
											setEdited(false);
										} else if (Number(v) === Number(vendorCountMin)) {
											updateValue('vendorCountMin', v);
											updateValue('vendorCountMax', v);
										}
									}
								}}
							/>
						</CategoryInsightValue>
					</CategoryInsightRow>
					<CategoryInsightRow>
						<CategoryInsightLabel>
							Payment Terms threshold:
						</CategoryInsightLabel>
						<CategoryInsightValue>
							<ApInput
								type="number"
								name="paymentTerms"
								value={paymentTerms || ''}
								onChange={v => {
									updateValue('paymentTerms', v);
									setEdited(false);
								}}
							/>
						</CategoryInsightValue>
					</CategoryInsightRow>
					<CategoryInsightRow>
						<CategoryInsightLabel>
							Increased P-Card Threshold:
						</CategoryInsightLabel>
						<CategoryInsightValue>
							<ApInput
								type="number"
								name="pCardCategories"
								value={pCardCategories || ''}
								onChange={v => {
									updateValue('pCardCategories', v);
									setEdited(false);
								}}
							/>
						</CategoryInsightValue>
					</CategoryInsightRow>
					<CategoryInsightRow>
						<CategoryInsightLabel>
							Vendors for Out of Policy Spend:
						</CategoryInsightLabel>
						<CategoryInsightValue>
							<MultiSelectWrapper>
								<VendorMultiSelect
									name="out of policy spend"
									label={`Select  `}
									options={option}
									selected={selectedOption}
									disabled={false}
									isLoading={false}
									onChange={v => {
										updateValue('selectedOption', v);
										setEdited(false);
									}}
								/>
							</MultiSelectWrapper>
						</CategoryInsightValue>
					</CategoryInsightRow>
				</CategoryInsightData>
				<ApButtonSecondary
					onClick={() => {
						updateSettings(
							fragmentation,
							vendorCountMax,
							wellmanaged,
							vendorCountMin,
							paymentTerms,
							pCardCategories,
							selectedOption
						);
						setEdited(true);
					}}
					disabled={edited}
				>
					Save
				</ApButtonSecondary>
			</Container>
		</Wrapper>
	);
};

export default InsightsSettings;
